import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Quote } from 'lucide-react';

export const Testimonials = () => {
  const { t, language } = useLanguage();

  const testimonials = [
    { quote: t('testimonials.testimonial1.quote'), author: t('testimonials.testimonial1.author'), testId: 'testimonial-1' },
    { quote: t('testimonials.testimonial2.quote'), author: t('testimonials.testimonial2.author'), testId: 'testimonial-2' }
  ];

  return (
    <section id="testimonials" data-testid="testimonials-section" className="bg-[#FAFAF7] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-16 lg:px-24">
        {/* Aurven-style centered heading */}
        <div className="text-center mb-16">
          <span className="inline-block font-inter text-xs uppercase tracking-[0.25em] text-[#0A2235]/60 border border-[#0A2235]/15 px-4 py-1.5 rounded-sm mb-8">
            {language === 'es' ? 'Testimonios' : 'Reviews'}
          </span>
          <h2 className="font-playfair text-[clamp(2rem,5vw,4rem)] text-[#0A2235] leading-[1.08] tracking-tight">
            {language === 'es' ? (
              <>Historias de nuestros <em className="text-[#2BBFBF]">inversionistas</em></>
            ) : (
              <>Stories from our <em className="text-[#2BBFBF]">investors</em></>
            )}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((testimonial) => (
            <div key={testimonial.testId} className="border border-[#0A2235]/10 rounded-2xl p-8 md:p-10 hover:shadow-lg transition-all duration-500" data-testid={testimonial.testId}>
              <Quote className="w-8 h-8 text-[#2BBFBF] mb-6 opacity-40" />
              <blockquote className="font-playfair text-lg md:text-xl text-[#0A2235] leading-relaxed mb-8 italic">
                "{testimonial.quote}"
              </blockquote>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 bg-[#0A2235] rounded-full flex items-center justify-center text-[#2BBFBF] font-playfair text-sm font-bold">
                  {testimonial.author.charAt(0)}
                </div>
                <p className="font-inter text-[#0A2235]/60 text-sm">{testimonial.author}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
